const SmsRateUpload = () => {
    return (
        <div>
            <h1>SMS Rate Upload</h1>
        </div>
    )
}

export default SmsRateUpload;